import { parseISO } from "date-fns/parseISO";
import { isPast } from "date-fns/isPast";
import { isToday } from "date-fns/isToday";

import "./sportnyhet-data-template.scss";

const queryAll = (selector, el) => {
	const parent = el || document;
	return Array.from(parent.querySelectorAll(selector));
};

const query = (selector, el) => queryAll(selector, el).shift();

const useFetch = (formData) => {
	return new Promise((resolve, reject) => {
		fetch(filters_ajax.url, {
			method: "POST",
			body: formData,
		})
			.then((res) => res.json())
			.then(resolve)
			.catch(reject);
	});
};

const checkLive = (root) => {
	const { id, datetime } = root.dataset;

	const dt = parseISO(datetime);

	if (!isToday(dt) || !isPast(dt)) {
		return;
	}

	const formData = new FormData();
	formData.append("action", "snd/match/live");
	formData.append("id", id);

	const homeScoreEl = query(".snm-score--home");
	const awayScoreEl = query(".snm-score--away");
	const labelEl = query(".snm-status");

	useFetch(formData).then((response) => {
		const { success, data } = response;

		if (!success) {
			return;
		}

		const {
			is_finished: isFinished,
			is_live: isLive,
			home_score: homeScore,
			away_score: awayScore,
			label,
			status,
		} = data;

		labelEl.innerText = label;
		homeScoreEl.innerText = homeScore;
		awayScoreEl.innerText = awayScore;
		root.dataset.status = status;

		root.classList.toggle("snm--live", isLive);

		if (!isFinished) {
			setTimeout(() => checkLive(root), 1e4 * 2);
		}
	});
};

const parentFindLinksAndClick = (selector) => {
	queryAll(selector).forEach((parent) => {
		const links = queryAll("a", parent);

		if (!links.length) {
			return;
		}

		parent.classList.add("snm-link-parent");

		links.forEach((link) =>
			link.addEventListener("click", (event) => event.stopPropagation())
		);

		const [firstLink] = links;

		parent.addEventListener("click", () => firstLink.click());
	});
};

const init = () => {
	const root = query("#snm");

	if (!root) {
		return;
	}

	const tabs = queryAll(".snm-tab");
	const tabLinks = queryAll(".snm-tabs-link");

	const activateTab = (tabLink) => {
		tabLinks.forEach((el) => el.classList.remove("snm-tabs-link--active"));
		tabLink.classList.add("snm-tabs-link--active");

		tabs.forEach((el) => el.classList.remove("snm-tab--active"));
		const tab = query(tabLink.getAttribute("href"));
		tab.classList.add("snm-tab--active");
	};

	tabLinks.forEach((tabLink) =>
		tabLink.addEventListener("click", (event) => {
			event.preventDefault();
			activateTab(tabLink);
		})
	);

	checkLive(root);

	parentFindLinksAndClick(".snm-odds-row");
	parentFindLinksAndClick(".snm-offer-row");
};

document.addEventListener("DOMContentLoaded", init);
